import { Box, Typography } from '@mui/material';

import { getChartLabelByDCM } from '../../../../../utils';
import TargetChart from './TargetChart';
import {
  PDF_CHART_TITLE_SX,
  PDF_CHART_WRAPPER_SX,
  PDF_FIELD_LABEL_SX,
  PDF_FIELD_ROW_SX,
  PDF_TARGET_CARD_SX,
  PDF_TARGET_COLUMN_SX,
  PDF_TARGET_HEADER_SX,
} from '../styles';
import {
  getAverageUnitLabel,
  getChartUnitSuffix,
  getDurationUnitLabel,
  getGoalTypeLabel,
} from '../utils';

import type { PdfTargetSectionProps } from './types';

export default function PdfTargetSection({ targetData, isPageBreak }: PdfTargetSectionProps) {
  const durationUnitLabel = getDurationUnitLabel(targetData.durationDCMEventUnit);
  const chartUnitSuffix = getChartUnitSuffix(
    targetData.dcm,
    targetData.durationDCMEventUnit,
    targetData.rateUnit,
  );

  return (
    <Box sx={PDF_TARGET_CARD_SX} className={isPageBreak ? 'page-break' : ''}>
      <Box sx={PDF_TARGET_HEADER_SX}>
        <Box sx={PDF_TARGET_COLUMN_SX}>
          <Box sx={PDF_FIELD_ROW_SX}>
            <Typography sx={PDF_FIELD_LABEL_SX}>Goal: </Typography>
            <Typography textAlign="left">{targetData.goalLabel}</Typography>
          </Box>
          <Box sx={PDF_FIELD_ROW_SX}>
            <Typography sx={PDF_FIELD_LABEL_SX}>Goal type:</Typography>
            <Typography textAlign="left">{getGoalTypeLabel(targetData.goalType)}</Typography>
          </Box>
        </Box>
        <Box sx={PDF_TARGET_COLUMN_SX}>
          <Box sx={PDF_FIELD_ROW_SX}>
            <Typography sx={PDF_FIELD_LABEL_SX}>Target:</Typography>
            <Typography textAlign="left">{targetData.targetLabel}</Typography>
          </Box>
          <Box sx={PDF_FIELD_ROW_SX}>
            <Typography sx={PDF_FIELD_LABEL_SX}>{targetData.averageLabel}:</Typography>
            <Typography textAlign="left">
              {targetData.average}
              {` ${getAverageUnitLabel(targetData.dcm, durationUnitLabel)}`}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={PDF_CHART_TITLE_SX}>
        <Typography fontSize={12} fontWeight={700}>
          {`(${getChartLabelByDCM(targetData.dcm)}${chartUnitSuffix})`}
        </Typography>
      </Box>

      <Box sx={PDF_CHART_WRAPPER_SX}>
        <TargetChart targetData={targetData} />
      </Box>
    </Box>
  );
}
